<template>
  <header class="d-flex justify-content-between header">
    <div class="d-flex align-items-center">
      <operation-list></operation-list>
      <div class="d-flex align-items-center">
        <router-link class="factory-name" to="/"><h1>{{factoryName}}</h1></router-link>
        <breadcrumbs></breadcrumbs>
      </div>
    </div>
    <div>
      <factory-toggler></factory-toggler>
    </div>
    <div class="d-flex">
      <app-contacts></app-contacts>
      <app-notifications class="notifications__wrapper"></app-notifications>
      <b-dropdown right :text="this.username" class="header__dropdown" size="sm">
        <div v-for="lang in languages" :key="lang.name">
          <b-dropdown-item @click="changeLang(lang.name)" class="dropdown-item"
                           :title="lang.name">
            <img class="lang-icon" :src=lang.imageSrc>
          </b-dropdown-item>
          <b-dropdown-divider></b-dropdown-divider>
        </div>
        <b-dropdown-item @click.prevent="logout" class="logout-btn">Logout</b-dropdown-item>
      </b-dropdown>
    </div>
  </header>
</template>

<script>
  import Vue from 'vue';
  import { mapState } from 'vuex';
  import { setNotifyData } from '@/helpers/commonHelpers';
  import AppNotifications from './Notifications';
  import AppContacts from './Contacts';
  import OperationList from '@/components/common/OperationsList';
  import Breadcrumbs from '@/components/common/Breadcrumbs';
  import FactoryToggler from '@/components/common/FactoryToggler';
  import { FACTORY_NAME } from '@/config/config';

  export default {
    props: ['username'],
    components: {
      AppNotifications,
      AppContacts,
      OperationList,
      Breadcrumbs,
      FactoryToggler
    },
    data() {
      return {
        factoryName: FACTORY_NAME,
        languages: [
          {
            name: 'lt',
            imageSrc: require('../../assets/images/language-icons/lt.svg')
          },
          {
            name: 'ru',
            imageSrc: require('../../assets/images/language-icons/ru.svg')
          },
          {
            name: 'en',
            imageSrc: require('../../assets/images/language-icons/en.svg')
          }],
        showMenuFlag: true
      }
    },
    methods: {
      logout() {
        this.$http.post(`logout/`).then(_ => {
          localStorage.removeItem('login');
          localStorage.removeItem('token');
          this.$router.push('/login');
        }).catch(e => {
          console.log(e);
          this.$notify(setNotifyData(this.$i18n.t(`notifications.common.error`), '', 'error'));
        })
      },
      changeLang(lang) {
        Vue.http.headers.common['Accept-Language'] = lang;
        localStorage.setItem('lang', lang);
        location.reload();
        this.$i18n.locale = lang;
      },
      toggleMenu() {
        this.showMenuFlag = !this.showMenuFlag;
        this.$emit('toggleMenu', this.showMenuFlag);
      },
    },
    computed: {
      ...mapState('location', ['pathName']),
    }
  }
</script>

<style scoped lang="scss">
  .factory-name {
    text-decoration: unset;
    color: rgba(#000, 1);
    transition: .3s;

    &:hover, &:active {
      color: rgba(#000, .75);
    }

    h1 {
      font-family: Myriad, sans-serif;
      text-transform: capitalize;
      font-size: 1.75rem;
      margin: 0 0 0 10px;
      font-weight: bold;
    }
  }

  .granules-link {
    display: flex;
    align-items: center;
    margin-right: 20px;

    span {
      margin-left: 5px;
    }
  }

  .dropdown-item {
    text-align: center;
    padding: 0;
  }

  .dropdown-divider {
    margin: 0;
  }

  .lang-icon {
    height: 13px;
    width: 20px;
  }

  .header {
    margin-left: 105px;
  }

  .header__toggle-button {
    padding-top: 6px;
    color: #423c3c;
    border-color: #d4c5c5;

    &:hover {
      background: #f5f7f7;
    }
  }

  .logout-btn {
    font-size: 12px;
    text-align: center;
  }

  .notifications__wrapper {
    margin-right: 20px;
  }

</style>



// WEBPACK FOOTER //
// src/components/common/Header.vue